import { CountryCode, getCountries, getCountryCallingCode } from 'libphonenumber-js';

export const countries = getCountries().map((countryCode: CountryCode) => ({
  code: countryCode,
  label: new Intl.DisplayNames([navigator.language], { type: 'region' }).of(countryCode) || countryCode,
  countryCode: `+${getCountryCallingCode(countryCode)}`,
}));
